/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Import Redux
import {
  verifyCINGet,
  verifyDINGet,
  verifyThisPANGet,
} from "../../../../redux/features/verifyPAN/verifyPAN.js";
import { getUserSpecificEntity } from "../../../../redux/features/Settings/Management/entities/index.js";

// Import components
import Loader from "../../../../components/Loader/Index";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import GeoMapLeaflet from "../../../../components/_utils/GeoMapLeaflet/index.jsx";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";

// Import Utils
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import TEXT from "../../../../utils/globalText";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import formatCurrency from "../../../../utils/CurrencyFormater.js";
import useServiceChecker from "../../../../components/ServiceChecker/index.jsx";
import PanVerification from "../../PanVerification/index.jsx";
import CINVerification from "../../CINVerification/index.jsx";
import DINVerification from "../../DINVerification/index.jsx";

const EntityDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();
  const [ensureAny] = useServiceChecker();
  // switcher tabs states
  const [showDetails, setShowDetails] = useState(true);
  const [showCinDetails, setShowCinDetails] = useState(false);
  const [showDinDetails, setShowDinDetails] = useState(false);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(
    showDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showCinDetails
        ? GlobalConfiguration?.lengthCheckOne
        : showDinDetails
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );

  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  // Popup states
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showCINPopup, setCINShowPopup] = useState(false);
  const [showDINPopup, setDINShowPopup] = useState(false);
  const [dinNo, setDinNo] = useState("");

  const { getEntityLoading, getEntityData } = useSelector(
    (state) => state.entities,
  );

  const specificEntityData = getEntityData?.entities?.find(
    (entity) => entity.entity_id === id,
  );

  let cinDetailsData = specificEntityData?.cin_details;

  let dinDetailsData = cinDetailsData?.directors;

  const toggleDetails = () => {
    setShowDetails(true);
    setShowCinDetails(false);
    setShowDinDetails(false);
  };

  const toggleCinDetails = () => {
    setShowDetails(false);
    setShowCinDetails(true);
    setShowDinDetails(false);
  };

  const toggleDinDetails = () => {
    setShowDetails(false);
    setShowCinDetails(false);
    setShowDinDetails(true);
  };

  const formatDate = (GSTDate) => {
    let dateObj = new Date(GSTDate);

    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    let month = dateObj.toLocaleString("default", { month: "short" });
    let formattedDate = `${day} ${month}, ${year}`;

    return formattedDate;
  };

  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setTimeout(() => {
        setPrevIndex(tabIndex);
      }, IntervalConfiguration?.intervalSemiMid);
    }
  }, [tabIndex]);

  useEffect(() => {
    dispatch(getUserSpecificEntity());
  }, []);

  useEffect(() => {
    if (specificEntityData?.entity_address) {
      setLoading(false);
    }
  }, [specificEntityData]);

  return (
    <>
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: specificEntityData?.entity_pan,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={specificEntityData?.entity_pan}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showCINPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="CIN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/CIN_verification`, {
                state: { cinNumber: cinDetailsData?.cin_number },
              })
            }
            closeiconhandleFunction={() => setCINShowPopup(false)}
          >
            <CINVerification
              cin_no={cinDetailsData?.cin_number}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showDINPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="DIN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/DIN_verification`, {
                state: { dinNumber: dinNo },
              })
            }
            closeiconhandleFunction={() => setDINShowPopup(false)}
          >
            <DINVerification
              din_no={dinNo}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div className="flex flex-col overflow-y-auto overflow-x-hidden bg-primary-bg h-full-height">
        {getEntityLoading ? (
          <div className="flex items-center justify-center loader-container m-auto">
            <Loader />
          </div>
        ) : (
          <>
            <div className="hidden Qsmd:block Qsmd:h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>

            {/* Responsive page header */}
            <div className="Qsmd:hidden fixed w-width-full top-top-base bg-primary-nav flex items-center z-z-index-fixed-ui shadow-box-shadow-bottom">
              <TopNavComponent
                isFormattingNotRequired={true}
                topNavHeader="Entities"
                topNavSubText="Entity details"
              />
            </div>

            <div className="w-width-full bg-primary-nav">
              <div className="max-w-tab-width-normal mx-auto Qsmd:px-padding-md Qlg:px-padding-base">
                <div className="flex flex-col pt-[var(--mobile-create-header)] Qsmd:pt-padding-base Qsmd:mt-margin-base Qlg:px-padding-base Qsmd:px-padding-md">
                  <div className="flex-1 py-padding-md border-b border-solid border-primary-bg px-padding-md Qmd:px-padding-base">
                    <div className="pl-padding-base Qmd:pl-padding-sm">
                      <TitleSubtitlePair
                        title={specificEntityData?.entity_name
                          ?.toLowerCase()
                          ?.split(" ")
                          ?.map(
                            (word) =>
                              word
                                .charAt(GlobalConfiguration?.lengthCheckZero)
                                .toUpperCase() +
                              word.slice(GlobalConfiguration?.lengthCheckOne),
                          )
                          ?.join(" ")}
                        subtitle={"Entity name"}
                        titleColor={"text-primary"}
                        isBold={false}
                        variant="md"
                        textAlign={"left"}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col Qmd:flex-row py-padding-base Qmd:py-padding-sm">
                    <div className="flex items-center w-width-md pl-padding-md py-padding-md Qmd:pl-padding-sm Qmd:py-padding-base">
                      <TitleSubtitlePair
                        title={specificEntityData?.entity_id}
                        subtitle={"Entity ID"}
                        titleColor={"text-primary"}
                        isBold={false}
                        variant="md"
                        textAlign={"left"}
                      />
                    </div>

                    <div className="hidden Qmd:block border-r border-solid border-primary-bg my-margin-sm"></div>
                    <div className="block Qmd:hidden border-b border-solid border-primary-bg"></div>

                    <div className="flex flex-grow-0 pl-padding-sm Qmd:pl-padding-md py-padding-sm Qmd:py-padding-base">
                      <TitleSubtitlePair
                        title={specificEntityData?.entity_pan}
                        subtitle={"PAN number"}
                        titleColor={"text-primary"}
                        isBold={false}
                        variant="md"
                        textAlign={"left"}
                        showArrow={true}
                        hoverOption={"white"}
                        onClick={() => {
                          if (ensureAny(["VPAN"]).status) {
                            setPanShowPopup(true);
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "VPAN",
                              },
                            });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Switcher Tab & Additional Details */}
            <div>
              <div className="m-auto max-w-tab-width-normal">
                <div className="flex pt-padding-md px-padding-md Qlg:px-padding-base">
                  <div className="flex gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                    <SwitcherTabs
                      tabs={[
                        {
                          label: "Details",
                          key: "details",
                          handler: toggleDetails,
                        },
                        {
                          label: "CIN details",
                          key: "cin details",
                          handler: toggleCinDetails,
                        },
                        {
                          label: "DIN details",
                          key: "din details",
                          handler: toggleDinDetails,
                        },
                      ]}
                      initialActiveTab={
                        showCinDetails
                          ? "cin details"
                          : showDinDetails
                            ? "din details"
                            : "details"
                      }
                      setIndex={setTabIndex}
                    />
                  </div>
                </div>

                {tabIndex === GlobalConfiguration?.lengthCheckZero && (
                  <div className={animationClass}>
                    <div className="flex flex-col Qsmd:flex-row my-margin-md gap-gap-md">
                      <div className="shrink-0 px-padding-md lg:px-padding-base">
                        <CommonDetailCard
                          cardTitle="Origin Details"
                          numCols={1}
                          variant="third"
                          entries={[
                            {
                              heading: "Created on",
                              content: formatDateViewAll(
                                specificEntityData?.entity_activate_date,
                                true,
                                true,
                              ),
                              type: "text",
                            },
                          ]}
                        />
                      </div>
                      {specificEntityData?.entity_address?.length >
                        GlobalConfiguration?.lengthCheckZero && (
                        <div className="flex-1 min-w-0">
                          <CommonContainerCard header={TEXT?.CORPORATE_ADDRESS}>
                            <div className="flex flex-col gap-gap-md md:flex-row Qmd:flex-row items-start justify-between ">
                              <div className="flex w-width-full Qmd:flex-1 flex-col gap-y-gap-xs">
                                <p className="text-text-primary text-font-sm font-normal">
                                  {specificEntityData?.entity_address}
                                </p>
                              </div>

                              {!loading ? (
                                <div className="w-width-full Qmd:w-map-leaflet-width flex justify-center Qmd:justify-center md:justify-end z-z-index-content">
                                  <GeoMapLeaflet
                                    address={specificEntityData?.entity_address}
                                    owner="cin_details"
                                    enableGeocoding={false}
                                  />
                                </div>
                              ) : (
                                <SVGComponent
                                  url={
                                    "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                  }
                                  height={"var(--icon-md)"}
                                  width={"var(--icon-md)"}
                                  alt="Loader"
                                />
                              )}
                            </div>
                          </CommonContainerCard>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {tabIndex === GlobalConfiguration?.lengthCheckOne && (
                  <div className={`${animationClass} flex flex-col`}>
                    {cinDetailsData ? (
                      <div className="flex flex-col my-margin-md gap-gap-md">
                        <div className="px-padding-md lg:px-padding-base">
                          <CommonDetailCard
                            cardTitle="CIN Details"
                            numCols={GlobalConfiguration?.lengthCheckFour}
                            variant="four"
                            entries={[
                              {
                                content: cinDetailsData?.cin_number,
                                heading: "CIN number",
                                type: "text",
                                onClick: () => {
                                  if (ensureAny(["VCIN"]).status) {
                                    setCINShowPopup(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VCIN",
                                      },
                                    });
                                  }
                                },
                              },
                              {
                                content: cinDetailsData?.company_class,
                                heading: "Class of company",
                                type: "text",
                              },
                              {
                                content: cinDetailsData?.company_status,
                                heading: "Company status",
                                type: "text",
                              },
                              {
                                content: cinDetailsData?.hasOwnProperty(
                                  "paid_up_capital",
                                )
                                  ? cinDetailsData?.paid_up_capital
                                    ? `INR ${formatCurrency(cinDetailsData?.paid_up_capital)}`
                                    : "Not given"
                                  : "Not available",
                                heading: "Paid up capital",
                                type: "text",
                              },
                              {
                                content: cinDetailsData?.company_name,
                                heading: "Company name",
                                type: "text",
                              },
                              {
                                content: cinDetailsData?.client_id,
                                heading: "Email ID",
                                type: "text",
                              },
                              {
                                content: cinDetailsData?.listed_status,
                                heading: "Listed status",
                                type: "text",
                              },
                              {
                                content: cinDetailsData?.hasOwnProperty(
                                  "authorized_capital",
                                )
                                  ? cinDetailsData?.authorized_capital
                                    ? `INR ${formatCurrency(cinDetailsData?.authorized_capital)}`
                                    : "Not given"
                                  : "Not available",
                                heading: "Authorized capital",
                                type: "text",
                              },
                              {
                                content: formatDateViewAll(
                                  cinDetailsData?.last_updated_on,
                                  true,
                                  true,
                                ),
                                heading: "Last updated on",
                                type: "text",
                              },
                              {
                                content: formatDate(
                                  cinDetailsData?.incorporation_date,
                                ),
                                heading: "Incorporation date",
                                type: "text",
                              },
                              {
                                content: formatDate(
                                  cinDetailsData?.last_agm_date,
                                ),
                                heading: "Last AGM date",
                                type: "text",
                              },
                              {
                                content: formatDate(
                                  cinDetailsData?.last_bs_date,
                                ),
                                heading: "Last BS date",
                                type: "text",
                              },
                            ]}
                          />
                        </div>
                        <CommonContainerCard header={TEXT?.CORPORATE_ADDRESS}>
                          <div className="flex flex-col gap-gap-md md:flex-row Qmd:flex-row items-start justify-between">
                            <div className="flex w-width-full Qmd:flex-1 flex-col gap-y-gap-xs">
                              <p className="text-text-primary text-font-sm font-normal">
                                {cinDetailsData?.company_address}
                              </p>
                            </div>

                            {!loading ? (
                              <div className="w-width-full Qmd:w-map-leaflet-width flex justify-center Qmd:justify-center md:justify-end">
                                <GeoMapLeaflet
                                  address={cinDetailsData?.company_address}
                                  owner="cin_details"
                                />
                              </div>
                            ) : (
                              <SVGComponent
                                url={
                                  "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                }
                                height={"var(--icon-md)"}
                                width={"var(--icon-md)"}
                                alt="Loader"
                              />
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    ) : (
                      <div className="w-details-card-sm py-padding-md">
                        <CommonContainerCard header="CIN Details">
                          <p className="text-font-sm text-text-primary">
                            CIN data not available.
                          </p>
                        </CommonContainerCard>
                      </div>
                    )}
                  </div>
                )}

                {tabIndex === GlobalConfiguration?.lengthCheckTwo && (
                  <div className={animationClass}>
                    {showDinDetails &&
                    dinDetailsData?.length >
                      GlobalConfiguration?.lengthCheckZero ? (
                      <div className="py-padding-md grid grid-cols-1 gap-gap-md Qsm:grid-cols-2 sm:grid-cols-3 Qsmd:grid-cols-4 px-padding-md Qlg:pl-padding-base">
                        {dinDetailsData?.map((data, i) => (
                          <CommonDetailCard
                            key={i}
                            cardTitle={data?.director_name
                              ?.toLowerCase()
                              ?.split(" ")
                              ?.map(
                                (word) =>
                                  word
                                    .charAt(
                                      GlobalConfiguration?.lengthCheckZero,
                                    )
                                    .toUpperCase() +
                                  word.slice(
                                    GlobalConfiguration?.lengthCheckOne,
                                  ),
                              )
                              ?.join(" ")}
                            numCols={GlobalConfiguration?.lengthCheckOne}
                            variant="fourth"
                            entries={[
                              {
                                heading: "DIN number",
                                content: data?.din_number,
                                type: "text",
                              },
                            ]}
                            onClick={() => {
                              if (ensureAny(["VDIN"]).status) {
                                setDINShowPopup(true);
                                setDinNo(data?.din_number);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "VDIN",
                                  },
                                });
                              }
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      <div className="w-details-card-sm py-padding-md">
                        <CommonContainerCard header="DIN Details">
                          <p className="text-font-sm text-text-primary">
                            DIN data not available.
                          </p>
                        </CommonContainerCard>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EntityDetails;
